import React, { useState, useEffect, Suspense } from "react"
import { Slice } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import ScrollToTop from "./ScrollToTop"

const Cookies = React.lazy(() => import("./Cookies"))
const GlobalPopup = React.lazy(() => import("./Popup/GlobalPopup"))

const Layout = ({ children }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const [isClient, setIsClient] = useState(false)

  const data = useStaticQuery(graphql`
    query {
      upcomingClass: allWpCookingClass(
        sort: { cookingClasses: { classSchedule: DESC } }
      ) {
        edges {
          node {
            cookingClasses {
              classDescription
              classSchedule
              classUrl
            }
            title
            featuredImage {
              node {
                gatsbyImage(
                  formats: WEBP
                  width: 720
                  placeholder: BLURRED
                  quality: 85
                )
              }
            }
          }
        }
      }
      popupBG: file(relativePath: { eq: "cooking_classes_hero.webp" }) {
        childImageSharp {
          gatsbyImageData(
            formats: WEBP
            quality: 85
            layout: FULL_WIDTH
            height: 580
            placeholder: BLURRED
          )
        }
      }
    }
  `)
  const now = new Date()

  // gets the latest upcoming cooking class
  const upcomingClasses = data?.upcomingClass?.edges
    .filter(edge => {
      const classDate = new Date(
        edge.node?.cookingClasses?.classSchedule?.replace("+00:00", "-07:00")
      )
      return classDate >= now
    })
    .sort((a, b) => {
      const dateA = new Date(
        a.node?.cookingClasses?.classSchedule?.replace("+00:00", "-07:00")
      )
      const dateB = new Date(
        b.node?.cookingClasses?.classSchedule?.replace("+00:00", "-07:00")
      )
      return dateA - dateB // closest to now
    })

  // backup cooking classes sort that contains all of the classes sorted from latest to oldest
  const sortedClasses = data?.upcomingClass?.edges.sort((a, b) => {
    const dateA = new Date(
      a.node?.cookingClasses?.classSchedule?.replace("+00:00", "-07:00")
    )
    const dateB = new Date(
      b.node?.cookingClasses?.classSchedule?.replace("+00:00", "-07:00")
    )

    return dateB - dateA
  })

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   // window.scroll({ top: 0, behavior: 'smooth', });
  // }, []);

  const handlePopupDismiss = () => {
    setIsPopupVisible(false)
    sessionStorage.setItem("popupDismissed", false)
  }

  useEffect(() => {
    setIsClient(true)
    const dismissed = sessionStorage.getItem("popupDismissed")
    if (document.readyState === "complete") {
      if (!dismissed && window.location.pathname !== "/cooking-classes/") {
        setTimeout(() => {
          setIsPopupVisible(true)
        }, 8000)
      }
    }
  }, [])

  return (
    <>
      <Slice alias="header"></Slice>
      <ScrollToTop />
      <main className="content">{children}</main>
      {isClient && (
        <Suspense fallback={null}>
          <Cookies />
        </Suspense>
      )}
      {isClient && (
        <Suspense fallback={null}>
          <GlobalPopup
            isVisible={false}
            onClose={() => handlePopupDismiss()}
            link={
              upcomingClasses[0]?.node.cookingClasses?.classUrl ||
              sortedClasses[0]?.node.cookingClasses?.classUrl ||
              "https://homemadecooking.com/classes/"
            }
            imageBG={data?.popupBG}
          />
        </Suspense>
      )}

      <Slice alias="footer"></Slice>
    </>
  )
}

export default Layout
